'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotFound = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBodyClassname = require('react-body-classname');

var _reactBodyClassname2 = _interopRequireDefault(_reactBodyClassname);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotFound = exports.NotFound = function NotFound() {
  return _react2.default.createElement(
    _reactBodyClassname2.default,
    { className: 'sticky--header body--error body--no-footer body--render-error' },
    _react2.default.createElement(
      'div',
      { className: 'render-error' },
      _react2.default.createElement('img', { className: 'render-error__arm', src: require('../../../static/img/404-arm.png'), alt: 'Arm', width: '599', height: '548' }),
      _react2.default.createElement('img', { className: 'render-error__kettlebell', src: require('../../../static/img/404-weight.png'), alt: 'Weight', width: '654', height: '464' }),
      _react2.default.createElement(
        'section',
        { className: 'render-error__content' },
        _react2.default.createElement(
          'h1',
          null,
          '404'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Whoops!',
          _react2.default.createElement('br', null),
          'That\u2019s not how we wanted this to go.'
        )
      )
    )
  );
};